import { render } from "./PopUpWindow.vue?vue&type=template&id=4fbe1f48&scoped=true"
import script from "./PopUpWindow.vue?vue&type=script&lang=js"
export * from "./PopUpWindow.vue?vue&type=script&lang=js"

import "./PopUpWindow.vue?vue&type=style&index=0&id=4fbe1f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbe1f48"]])

export default __exports__